import { createContext, useEffect, useRef, useState } from "react";
import { logIn, logOut, verifySessionToken} from "../../services/auth";
import { getFooterItems } from "../../services/footer";
import { notificationError, notificationSucces } from "../../services/notification";
import { getPermission } from "../../services/permisssion";
import permissionType from "../../utils/permissionType";
import { IAuthProvider, IContext, IUser } from "./types";
import { getUserLocalStorage, setUserLocalStorage } from "./utils";
import { useNavigate } from "react-router-dom";

export const AuthContext = createContext<IContext>({} as IContext)
const TOKEN_EXPIRATION_TIME = 10 * 1000
const VERSION_EXPIRATION_TIME = 60 * 1000
export const AuthProvider = ({ children }: IAuthProvider) => {
  const [user, setUser] = useState<IUser | null>();
  const [canEdit, setCanEdit] = useState<boolean>(false)
  const [version, setVersion] = useState<string | null>(null);
  const ref = useRef<any | null>(null)
  const refVersion = useRef<any | null>(null)

  useEffect(() => {
    const user = getUserLocalStorage()
    if (user) setUser(user)
  }, [])

  useEffect(() => {
    ref.current = setInterval(verifySession, TOKEN_EXPIRATION_TIME);
    if(window.location.pathname !== '/') {
      verifySession();
    }
    return () => {
      if(ref.current){
        clearInterval(ref.current)
      }
    }
  }, [])

  useEffect(() => {
    refVersion.current = setInterval(checkVersion, VERSION_EXPIRATION_TIME);
    if(window.location.pathname !== '/') {
      checkVersion();
    }
    return () => {
      if(refVersion.current){
        clearInterval(refVersion.current)
      }
    }
  }, [])

  async function authenticate(email: string, password: string) {
    try {
      const response = await logIn({email, password}) 
      if(response && response.return === true) {
        const payload = { response, email }
        setUser(payload)
        setUserLocalStorage(payload)
        notificationSucces('Signed in successfully')
      }
      if(!response) {
        notificationError('Could not log in')
      }
    } catch (e) {
      notificationError(`${e}`)
    }
  }

  async function validadeAccess(pageAccess: string) {
    try {
      const permission = await getPermission(pageAccess)
      setCanEdit(permission === permissionType.manage ? true : false)
    } catch (e) {
      notificationError(`${e}`)
    }
  }

  async function logout() {
    try {
      console.log("Logging out  - " + window.location.pathname)
      const response = await logOut() 
      setUser(null)
      setUserLocalStorage(null)
      if(response.return === false) {
        notificationError(`Error at requesting logout`)
      }
    } catch (e) {
      setUser(null)
      setUserLocalStorage(null)
      notificationError(`${e}`)
    }
    window.location.reload();
    window.location.href = '/'
  }

  const verifySession = async () => {
    if(window.location.pathname === '/') return
    const session = await verifySessionToken()
    if(session) return
    if(!session) {
      logout()
    }
   }

  const checkVersion = async () => {
    if(window.location.pathname === '/') return
    const res = await getFooterItems()
    if (version && version!== "" && version !== res.version) {
      // out of sync, refresh
      window.location.reload();
    }
    setVersion(res.version);

  }


  return (
    <AuthContext.Provider value={{ ...user, authenticate, logout, validadeAccess, canEdit }}>
      {children}
    </AuthContext.Provider>
  )
}